module.exports = __webpack_public_path__ + "media/images/gifts/autonomy/sug_autonomia_1-6351757e4180c74e4ab01ca863fda160.jpg";